export default "__VITE_ASSET__6pHnkK3x__"